import angular from 'angular';
import uiRouter from 'angular-ui-router';
import commondrgchangesComponent from './commondrgchanges.component';

let commondrgchangesModule = angular.module('commondrgchanges', [
  uiRouter
])

.component('commondrgchanges', commondrgchangesComponent);

export default commondrgchangesModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/commondrgchanges/commondrgchanges.js